// url
export default "https://vintage-tech-store-react-api.herokuapp.com";

// local fix
// setup free claudinary
